<wl-accordion
  [accordions]="accordions"
  [pageTitle]="pageTitle$ | async"
  [rendering]="rendering"
  wlCSCapture
/>
